<script setup>
import { computed } from 'vue'

const props = defineProps({
	videoId: {
		type: [Number, String],
		default: null,
	},
	videoLink: {
		type: String,
		default: null,
	},
})

const iframeSrc = computed(() => {
	return props.videoId
		? `https://vimeo.com/event/${props.videoId}/embed`
		: props.videoLink
})
</script>

<template>
	<div style="padding: 56.25% 0 0 0; position: relative" class="skeleton">
		<iframe
			:src="iframeSrc"
			style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
			frameborder="0"
			allow="autoplay; fullscreen; picture-in-picture"
			allowfullscreen
		></iframe>
		<slot></slot>
	</div>
</template>
